const actionTypes = {
  TOGGLE_LOADING: Symbol('TOGGLE_LOADING'),
  USER_LOGIN: Symbol('USER_LOGIN'),
};

export default actionTypes;
